export const EMAIL = 'email';
export const FULL_NAME = 'name';
export const MESSAGE = 'message';
